import { IonIcon } from "@ionic/react";
import styled, { keyframes, css } from "styled-components";

export const SliderViewport = styled.div`
  width: 100%;
  max-width: 48rem;
  overflow-x: hidden;
  position: relative;
  display: flex;
  justify-content: center;
  align-items: center;
`;

export const Arrow = styled(IonIcon)`
  position: absolute;
  top: 50%;
  font-size: 3.2rem;
  background-color: #d97706;
  color: #fff;
  border-radius: 50px;
  padding: 0.4rem;
  box-shadow: 0px 5px 25px rgba(1, 1, 1, 0.44);
  cursor: pointer;
  transition: all 300ms ease-in-out;
  z-index: 10;
  &:hover {
    background-color: #d977068c;
    color: black;
    box-shadow: none;
  }
  &.left {
    left: 0;
    transform: translate(50%, -50%);
  }
  &.right {
    right: 0;
    transform: translate(-50%, -50%);
  }
`;

export const SliderNav = styled.div`
  width: 100%;
  max-width: 48rem;
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin-top: 0.8rem;
  min-height: 3.6rem;
`;

export const NavButton = styled.button`
  display: inline-flex;
  align-items: center;
  gap: 0.6rem;
  background: rgba(255, 255, 255, 0.06);
  border: 1px solid rgba(217, 119, 6, 0.6);
  border-radius: 999px;
  color: #fff;
  font-size: 1.3rem;
  font-weight: 500;
  cursor: pointer;
  padding: 0.5rem 1.2rem;
  transition: all 200ms ease-in-out;

  &.next {
    flex-direction: row-reverse;
  }

  ion-icon {
    font-size: 1.8rem;
    color: #d97706;
    transition: all 200ms ease-in-out;
  }

  &:hover {
    background: #d97706;
    border-color: #d97706;
    transform: translateY(-1px);
    box-shadow: 0 4px 14px rgba(217, 119, 6, 0.4);
  }
  &:hover ion-icon {
    color: #fff;
  }
  &:active {
    transform: translateY(0);
    box-shadow: none;
  }
  &:focus-visible {
    outline: 2px solid #fff;
    outline-offset: 2px;
  }
`;

export const Category = styled.div`
  padding: 0.6rem 0.8rem;
  font-size: 1.6rem;
  background-color: #0a0a0a;
  margin-right: 0;
  border-top-right-radius: 10px;
  border-top-left-radius: 10px;
  margin-bottom: 1rem;

  ${(props) =>
    props.titleAnimation &&
    css`
      animation: ${TitleAnimation} 2s infinite;
    `}
`;

export const EmptyState = styled.div`
  width: 100%;
  max-width: 48rem;
  padding: 1.2rem;
  border-radius: 10px;
  background: rgba(255, 255, 255, 0.04);
  border: 1px solid rgba(255, 255, 255, 0.08);
  text-align: center;
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: 0.8rem;

  p {
    margin: 0;
    color: #cfcfcf;
    font-size: 1.4rem;
    line-height: 1.4;
  }
`;

const TitleAnimation = keyframes`
  0% {
    color: #fff;
    text-shadow: 0 0 0px #d97706;
    letter-spacing: normal;
  }

    50% {
      color: #d97706;
    text-shadow: 0 0 8px #d97706, 0 0 16px #d97706;
      letter-spacing: 0.1em;
    
    }

  100% {
  letter-spacing: normal;
    color: #fff;
    text-shadow: 0 0 0px #d97706;
  }
`;
